export const spacing = {
  0: 0,
  2: 2,
  4: 4,
  8: 8,
  12: 12,
  16: 16,
  20: 20,
  24: 24,
  32: 32,
  40: 40,
  48: 48,
  64: 64,
} as const

export const radius = { 0: 0, 8: 8, 16: 16, 20: 20, 24: 24, full: 9999 } as const

export const typography = {
  'heading-48': { fontSize: 48, lineHeight: 52.8, fontWeight: 600, letterSpacing: -1.44 },
  'heading-28': { fontSize: 28, lineHeight: 33.6, fontWeight: 600, letterSpacing: -0.56 },
  'heading-24': { fontSize: 24, lineHeight: 28.8, fontWeight: 600, letterSpacing: -0.48 },
  'heading-20': { fontSize: 20, lineHeight: 26, fontWeight: 600, letterSpacing: -0.2 },
  'heading-18': { fontSize: 18, lineHeight: 21.6, fontWeight: 600, letterSpacing: 0 },
  'body-20-medium': { fontSize: 20, lineHeight: 28, fontWeight: 500, letterSpacing: 0 },
  'body-16-semibold': { fontSize: 16, lineHeight: 20, fontWeight: 600, letterSpacing: 0 },
  'body-16-medium': { fontSize: 16, lineHeight: 22.4, fontWeight: 500, letterSpacing: 0 },
  'body-16-regular': { fontSize: 16, lineHeight: 22.4, fontWeight: 400, letterSpacing: 0 },
  'caption-14-semibold': { fontSize: 14, lineHeight: 18.2, fontWeight: 600, letterSpacing: 0 },
  'caption-14-medium': { fontSize: 14, lineHeight: 20.3, fontWeight: 500, letterSpacing: 0 },
  'caption-14-regular': { fontSize: 14, lineHeight: 21, fontWeight: 400, letterSpacing: 0 },
  'caption-13-medium': { fontSize: 13, lineHeight: 18.2, fontWeight: 500, letterSpacing: 0 },
  'caption-13-regular': { fontSize: 13, lineHeight: 18.2, fontWeight: 400, letterSpacing: 0 },
} as const

export type TypographyVariant = keyof typeof typography
